<!-- <app-notifications [class]="showNotification() ? 'fadeIn' : 'fadeOut'" /> -->
<app-notifications />

@if (location.path() !== '') {
    @if (initialized) {
        <app-header [routeName]="routeName"></app-header>
    }
    <app-sidebar (setRouteName)="setRouteName($event)" [routeName]="routeName"></app-sidebar>
}

<router-outlet></router-outlet>

<app-modal-confirmation
  #unsavedChangesConfirmation
  [id]="'unsavedChanges'"
  [modal]="unsavedChangesModal()!"
  [hidden]="!unsavedChangesShowed()"
  [shown]="unsavedChangesShowed()"
  [title]="'unsavedChanges.title'"
  [text]="unsavedChangesService.descriptionKey()"
  [confirmText]="'unsavedChanges.leave'"
  [cancelText]="'unsavedChanges.stay'"
  [icon]="images.alert"
  [centerText]="true"
  [sameLineButtons]="true"
  (action)="leaveWithUnsavedChanges()"
/>
